const CAMPAIGN_STORAGE_KEY = 'celluma_campaign_key';

class CampaignCollectionImages extends HTMLElement {
  connectedCallback() {
    this.campaignKeys = this.getCampaignKeys();
    if (!this.campaignKeys.length) return;

    this.applyCampaignImages();
    this.observeGrid();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  getCampaignKeys() {
    const keys = [];

    const collectionHandle = this.dataset.collectionHandle || '';

    const campaignKey = this.getCampaignKey(collectionHandle);
    if (campaignKey) keys.push(campaignKey);

    if (collectionHandle && !keys.includes(collectionHandle)) keys.push(collectionHandle);

    return keys;
  }

  getCampaignKey(collectionHandle) {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = params.get('utm_campaign');

    if (fromUrl) {
      try {
        sessionStorage.setItem(
          CAMPAIGN_STORAGE_KEY,
          JSON.stringify({ key: fromUrl, collection: collectionHandle })
        );
      } catch (err) {
        console.warn(err);
      }
      return fromUrl;
    }

    let stored;
    try {
      stored = sessionStorage.getItem(CAMPAIGN_STORAGE_KEY);
    } catch (err) {
      return null;
    }

    if (!stored) return null;

    let parsed;
    try {
      parsed = JSON.parse(stored);
    } catch (err) {
      return null;
    }

    if (!parsed || typeof parsed !== 'object') return null;
    if (parsed.collection !== collectionHandle) return null;

    return parsed.key || null;
  }

  static findMatch(campaignKeys, tile) {
    const raw = tile.dataset.campaignImages;
    if (!raw) return null;

    let images;
    try {
      images = JSON.parse(raw);
    } catch (err) {
      return null;
    }

    if (!Array.isArray(images)) return null;

    let match = null;

    campaignKeys.some((campaignKey) => {
      match = images.find((entry) => entry && entry.key === campaignKey && entry.src) || null;
      return match !== null;
    });

    return match;
  }

  applyCampaignImages() {
    const specialTiles = document.querySelectorAll('[data-campaign-images]');

    specialTiles.forEach((tile) => {
      const match = CampaignCollectionImages.findMatch(this.campaignKeys, tile);
      if (!match) return;

      const img = tile.querySelector('.product-tile__image');
      if (!img) return;

      if (img.dataset.campaignApplied === match.src) return;

      img.src = match.src;
      img.dataset.src = match.src;
      img.removeAttribute('srcset');
      img.dataset.campaignApplied = match.src;
    });

    if (window.lazy && typeof window.lazy.update === 'function') {
      window.lazy.update();
    }
  }

  observeGrid() {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid || typeof MutationObserver === 'undefined') return;

    this.observer = new MutationObserver(() => {
      this.applyCampaignImages();
    });

    this.observer.observe(grid, { childList: true, subtree: true });
  }
}

if (!customElements.get('campaign-collection-images')) {
  customElements.define('campaign-collection-images', CampaignCollectionImages);
}
